import { render, staticRenderFns } from "./SpaceRabbi.vue?vue&type=template&id=3665d01a&scoped=true&"
import script from "./SpaceRabbi.vue?vue&type=script&lang=js&"
export * from "./SpaceRabbi.vue?vue&type=script&lang=js&"
import style0 from "./SpaceRabbi.vue?vue&type=style&index=0&id=3665d01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665d01a",
  null
  
)

export default component.exports